// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner--3ibs2","spinnerBlock":"spinnerBlock--Chy7M","spinnerOverlay":"spinnerOverlay--2ZUjL","spinnerOverlayLimit":"spinnerOverlayLimit--3klgb"};